import {Form} from "@/utils/Form";
import DataSource, {BulkCapabilityFormValues} from "./dataSource";
import deepEqual from "deep-equal";
import {useDomainBulkCapabilityUpdateMutation} from "../mutations.generated";
import {DomainBulkCapabilityUpdateMutation, DomainBulkCapabilityUpdateMutationVariables} from "../mutations.generated";
import {CapabilityModificationType} from "@/api";

export default class DomainBulkCapabilityForm extends Form<
    DomainBulkCapabilityUpdateMutation,
    DomainBulkCapabilityUpdateMutationVariables,
    BulkCapabilityFormValues
> {
    private readonly domainId: number;
    readonly dataSource: DataSource;

    constructor(domainId: number, dataSource: DataSource) {
        super("domainBulkCapabilityUpdate");
        this.hooks(useDomainBulkCapabilityUpdateMutation, dataSource.initialData);
        this.domainId = domainId;
        this.dataSource = dataSource;
    }

    override async submit(): Promise<boolean> {
        const res = await super.submit();
        if (res) {
            await this.dataSource.fetch();
            this.clearCache();
            this.setInitial();
            this.reset();
        }
        return res;
    }

    // For some reason, this is necessary to make the used / allocted indicators update
    setInitial(): void {
        this.initialData = this.dataSource.initialData;
    }

    setCapability(name: string, newValue: CapabilityModificationType): void {
        const values = structuredClone(this.values.values);
        const target = values.find((cap) => cap.capability === name);
        target.changeType = newValue;
        this.updateValues({values: values});
    }

    protected override get filteredVariables(): DomainBulkCapabilityUpdateMutationVariables {
        return {
            domainId: this.domainId,
            changes: this.values.values.map((cap) => ({
                name: cap.capability,
                type: cap.changeType,
            })),
        };
    }

    override get hasChanged(): boolean {
        if (this.values) return !deepEqual(this.values, this.initialData);
        else return false;
    }
}
